export default "__VITE_ASSET__C2Y1ZDA2__"